import QueryString from 'qs';
import { API } from '.';

class JobService {
    async generateMatches(jobId) {
        try {
            const response = await API.post(`/api/jobs/${jobId}/matches`);
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async generateReverseMatches(
        contactId,
        { contractClientOnly = false } = {},
    ) {
        try {
            const query = contractClientOnly
                ? `?${QueryString.stringify({ contractClientOnly: true })}`
                : '';
            const response = await API.get(
                `/api/contacts/${contactId}/matches${query}`,
            );
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async createJob(data) {
        const response = await API.post('/api/jobs/client-create', {
            data,
        });
        return response.data;
    }

    async updateJob(jobId, data) {
        try {
            const response = await API.put(`/api/jobs/${jobId}/locations`, {
                data,
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async sendMessageToCandidates(
        jobId,
        message,
        messageType,
        candidacyStatuses,
    ) {
        try {
            const response = await API.post('/api/jobs/message', {
                data: {
                    jobId,
                    message,
                    candidacyStatuses,
                    type: messageType,
                },
            });
            return response.data;
        } catch (error) {
            throw new Error(error);
        }
    }

    async sendReport(jobId, email) {
        try {
            const response = await API.post('/api/jobs/report', {
                data: {
                    email: email,
                    jobId: jobId,
                },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async updateReportRecipients(jobId, reportRecipients) {
        try {
            const response = await API.put(`/api/jobs/${jobId}`, {
                data: {
                    reportRecipients,
                },
            });

            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async updateJobSeats(jobId, seats) {
        try {
            const response = await API.put(`/api/jobs/${jobId}`, {
                data: {
                    seats,
                },
            });

            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async closeJob(jobId) {
        try {
            const response = await API.post(`/api/jobs/${jobId}/close`);
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async updateJobStatus(jobId, status) {
        try {
            const response = await API.put(`/api/jobs/${jobId}/status`, {
                data: { status },
            });
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async updateApplicationLink(jobId, applicationLink) {
        try {
            const response = await API.put(
                `/api/jobs/${jobId}/application-link`,
                { data: { applicationLink } },
            );
            return response.data;
        } catch (error) {
            console.log(error);
            return null;
        }
    }
}

export default JobService;
